import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const GEMMA_LOGO = 'https://cdn.magicpatterns.com/uploads/gz8sA4fNn6wPKKG4dZRmq9/logo_instagram.png';
const testimonials = [{
  headline: 'omg I just took a shower ALONE',
  body: ['day 4. no rushing. no monitor panic.', 'happy tears lol'],
  name: 'sarah.momlife',
  stage: '6 weeks pp',
  avatar: 'https://i.pravatar.cc/80?img=45',
  time: '10:42 AM',
  reactionIndex: 0,
  reaction: '♡',
  gemmaReply: 'SO proud of you mama'
}, {
  headline: 'ok wait I have to tell you',
  body: ["baby still contact naps but I don't feel insane anymore??", 'the relief block is everything', 'my partner does it now without me asking'],
  name: 'jenn.and.baby',
  stage: '2 months pp',
  avatar: 'https://i.pravatar.cc/80?img=49',
  time: '8:15 PM',
  reactionIndex: 1,
  reaction: '♡',
  gemmaReply: "you're doing amazing"
}, {
  headline: 'this was the first thing that helped ME not just baby',
  body: ['I feel like myself again honestly'],
  name: 'patricia.newmom',
  stage: 'FTM, 8 weeks',
  avatar: 'https://i.pravatar.cc/80?img=26',
  time: '2:30 PM',
  reactionIndex: 0,
  reaction: '♡',
  gemmaReply: 'reading this with tears'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 15 : -15,
      opacity: 0,
      scale: 0.99
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
      scale: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 15 : -15,
      opacity: 0,
      scale: 0.99
    })
  };
  const swipeConfidenceThreshold = 10000;
  const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
  };
  const paginate = useCallback((newDirection: number) => {
    setDirection(newDirection);
    setCurrentIndex(prevIndex => {
      let nextIndex = prevIndex + newDirection;
      if (nextIndex < 0) nextIndex = testimonials.length - 1;
      if (nextIndex >= testimonials.length) nextIndex = 0;
      return nextIndex;
    });
  }, []);
  // Auto-play
  useEffect(() => {
    if (isPaused) {
      const resumeTimer = setTimeout(() => setIsPaused(false), 8000);
      return () => clearTimeout(resumeTimer);
    }
    const interval = setInterval(() => {
      paginate(1);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused, paginate]);
  const handleInteraction = () => setIsPaused(true);
  return <section className="relative pt-6 pb-12 md:pt-10 md:pb-20 px-6 md:px-8 bg-cream-dark overflow-hidden" data-id="element-763">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-sage/4 rounded-full blur-[100px] pointer-events-none" data-id="element-764" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-765">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center mb-10 md:mb-12" data-id="element-766">
          <div className="w-12 h-px bg-terracotta/30 mx-auto mb-6" data-id="element-767" />
          <p className="text-xs uppercase tracking-[0.2em] text-terracotta font-bold mb-4" data-id="element-768">
            Real DMs from real mamas
          </p>
          <h2 className="font-serif text-3xl md:text-5xl text-brown mb-5 leading-tight" data-id="element-769">
            They felt it too. Then they tried it.
          </h2>
          <p className="text-brown-light/80 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-770">
            Unedited messages from mothers in the 0–3 month phase.
          </p>
        </motion.div>

        {/* Carousel Container */}
        <div className="relative max-w-sm md:max-w-md mx-auto mb-10" data-id="element-771">
          {/* Desktop Navigation Arrows */}
          <button onClick={() => {
          handleInteraction();
          paginate(-1);
        }} className="absolute -left-16 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center w-10 h-10 text-brown/30 hover:text-brown/60 transition-colors z-20" aria-label="Previous testimonial" data-id="element-772">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8" data-id="element-773">
              <polyline points="15 18 9 12 15 6" data-id="element-774" />
            </svg>
          </button>

          <button onClick={() => {
          handleInteraction();
          paginate(1);
        }} className="absolute -right-16 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center w-10 h-10 text-brown/30 hover:text-brown/60 transition-colors z-20" aria-label="Next testimonial" data-id="element-775">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8" data-id="element-776">
              <polyline points="9 18 15 12 9 6" data-id="element-777" />
            </svg>
          </button>

          {/* Cards */}
          <div className="relative h-[480px] w-full flex items-center justify-center perspective-1000" data-id="element-778">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-779">
              <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                duration: 0.6,
                ease: [0.25, 0.1, 0.25, 1]
              },
              opacity: {
                duration: 0.6,
                ease: [0.25, 0.1, 0.25, 1]
              },
              scale: {
                duration: 0.6,
                ease: [0.25, 0.1, 0.25, 1]
              }
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={1} onDragStart={handleInteraction} onDragEnd={(e, {
              offset,
              velocity
            }) => {
              const swipe = swipePower(offset.x, velocity.x);
              if (swipe < -swipeConfidenceThreshold) {
                paginate(1);
              } else if (swipe > swipeConfidenceThreshold) {
                paginate(-1);
              }
            }} className="absolute w-full bg-white rounded-[1.5rem] flex flex-col overflow-hidden cursor-grab active:cursor-grabbing" style={{
              boxShadow: '0 12px 32px rgba(61,50,41,0.06), 0 2px 8px rgba(61,50,41,0.04)'
            }} data-id="element-780">
                {/* IG DM Header */}
                <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-3" data-id="element-781">
                  <div className="relative" data-id="element-782">
                    <div className="w-9 h-9 rounded-full p-[2px]" style={{
                    background: 'linear-gradient(135deg, #F58529, #DD2A7B, #8134AF, #515BD4)'
                  }} data-id="element-783">
                      <img src={testimonials[currentIndex].avatar} alt={testimonials[currentIndex].name} className="w-full h-full rounded-full object-cover border-2 border-white pointer-events-none" loading="lazy" decoding="async" data-id="element-784" />
                    </div>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-785">
                    <p className="text-[#262626] font-semibold text-[13px] leading-tight truncate" data-id="element-786">
                      {testimonials[currentIndex].name}
                    </p>
                    <p className="text-[#8e8e8e] text-[11px]" data-id="element-787">
                      {testimonials[currentIndex].stage} · Active now
                    </p>
                  </div>
                  {/* IG icons */}
                  <div className="flex items-center gap-3 text-[#262626]" data-id="element-788">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-789">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-790" />
                    </svg>
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-791">
                      <polygon points="23 7 16 12 23 17 23 7" data-id="element-792" />
                      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" data-id="element-793" />
                    </svg>
                  </div>
                </div>

                {/* Chat Body */}
                <div className="px-4 py-4 flex-1 flex flex-col gap-2 bg-[#FAFAFA]" data-id="element-794">
                  {/* Timestamp */}
                  <div className="text-center mb-2" data-id="element-795">
                    <span className="text-[10px] text-[#8e8e8e] font-normal" data-id="element-796">
                      {testimonials[currentIndex].time}
                    </span>
                  </div>

                  {/* Headline Bubble */}
                  <div className="flex items-end gap-2" data-id="element-797">
                    <img src={testimonials[currentIndex].avatar} alt="" className="w-5 h-5 rounded-full object-cover shrink-0 mb-0.5 opacity-0 pointer-events-none" loading="lazy" decoding="async" data-id="element-798" />
                    <div className="bg-white text-[#262626] font-medium text-[14px] leading-snug px-3.5 py-2.5 rounded-2xl rounded-tl-[4px] border border-gray-100 max-w-[88%]" data-id="element-799">
                      {testimonials[currentIndex].headline}
                    </div>
                  </div>

                  {/* Body Bubbles */}
                  {testimonials[currentIndex].body.map((line, j) => {
                  const isLast = j === testimonials[currentIndex].body.length - 1;
                  const hasReaction = j === testimonials[currentIndex].reactionIndex;
                  return <div key={j} className={`flex items-end gap-2 ${hasReaction ? 'mb-3' : ''}`} data-id="element-800">
                        {isLast ? <img src={testimonials[currentIndex].avatar} alt={testimonials[currentIndex].name} className="w-5 h-5 rounded-full object-cover shrink-0 mb-0.5 pointer-events-none" loading="lazy" decoding="async" data-id="element-801" /> : <div className="w-5 h-5 shrink-0" data-id="element-802" />}
                        <div className={`bg-white text-[#262626]/80 text-[13px] leading-relaxed px-3.5 py-2 rounded-2xl border border-gray-100 relative max-w-[88%] ${isLast ? 'rounded-bl-[4px]' : 'rounded-l-[4px]'}`} data-id="element-803">
                          {line}
                          {hasReaction && <div className="absolute -bottom-2.5 -right-1 bg-white rounded-full px-1 py-0.5 shadow-sm border border-gray-100 text-xs leading-none" data-id="element-804">
                              {testimonials[currentIndex].reaction}
                            </div>}
                        </div>
                      </div>;
                })}

                  {/* Gemma's Reply */}
                  <div className="flex items-end gap-2 justify-end mt-2" data-id="element-805">
                    <div className="text-white text-[13px] leading-relaxed px-3.5 py-2 rounded-2xl rounded-br-[4px] max-w-[88%]" style={{
                    background: 'linear-gradient(135deg, #515BD4, #8134AF, #DD2A7B)'
                  }} data-id="element-806">
                      {testimonials[currentIndex].gemmaReply}
                    </div>
                    <img src={GEMMA_LOGO} alt="gemmamama" className="w-5 h-5 rounded-full object-cover shrink-0 mb-0.5 pointer-events-none" loading="lazy" decoding="async" data-id="element-807" />
                  </div>
                </div>

                {/* IG DM Footer */}
                <div className="px-4 py-3 border-t border-gray-100 bg-white flex items-center gap-3" data-id="element-808">
                  <div className="flex-1 flex items-center gap-2 bg-[#EFEFEF] rounded-full px-4 py-2" data-id="element-809">
                    <span className="text-[#8e8e8e] text-[13px]" data-id="element-810">
                      Message...
                    </span>
                  </div>
                  <svg className="w-5 h-5 text-[#262626]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-811">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" data-id="element-812" />
                  </svg>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Dot Indicators */}
          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-813">
            {testimonials.map((_, i) => <button key={i} onClick={() => {
            handleInteraction();
            setDirection(i > currentIndex ? 1 : -1);
            setCurrentIndex(i);
          }} className={`transition-all duration-300 rounded-full ${i === currentIndex ? 'w-6 h-1.5 bg-terracotta/60' : 'w-1.5 h-1.5 bg-terracotta/20 hover:bg-terracotta/40'}`} aria-label={`Go to testimonial ${i + 1}`} data-id="element-814" />)}
          </div>
        </div>

        {/* Closing line */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center" data-id="element-815">
          <div className="w-12 h-px bg-terracotta/30 mx-auto mb-6" data-id="element-816" />
          <p className="font-serif text-xl md:text-2xl text-brown/60 italic leading-relaxed" data-id="element-817">
            Relief doesn't require perfect naps.
            <br data-id="element-818" />
            It requires structure.
          </p>
        </motion.div>
      </div>
    </section>;
}